export const getIsMockApi = () => {
  return (
    JSON.stringify(process.env.REACT_APP_API_MOCK) === JSON.stringify("true")
  );
};
